import { useContext } from 'react';

import { OSLocalesContext } from './index';

export function useOSLocales() {
  return useContext(OSLocalesContext);
}
